import * as React from "react";
import "./styles.css";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
function ReusableDeleteDialogue({
  isOpenDelete,
  heading,
  description,
  yesClicked,
  handleClose,
}) {
  // runs when close is clicked
  const handleCloseButton = () => {
    handleClose();
  };
  // runs when yes button is clicked
  const yesClickedButton = () => {
    console.log("yes has been clicked:");
    yesClicked();
  };
  return (
    <div>
      <Dialog
        PaperProps={{
          style: { borderRadius: ".6rem", padding: "1rem" },
        }}
        open={isOpenDelete}
        onClose={handleCloseButton}
      >
        <DialogTitle sx={{ padding: ".5rem" }} id="alert-dialog-title">
          {heading}
        </DialogTitle>

        <DialogContent sx={{ width: "24rem", margin: "1rem 0rem", height: "auto", padding: "1rem" }}>
          <DialogContentText id="alert-dialog-description">
            <span style={{ fontWeight: "400", fontSize:"1rem", color: "#333333" }}>
              {description}
            </span>
          </DialogContentText>
        </DialogContent>

        <div className="dialogButton">
          <Button
            onClick={yesClickedButton}
            color="error"
            sx={{
              width: "43%",
              color: "#BF5649",
              border: "2px solid #BF5649",
              fontFamily: "Be Vietnam Pro",
              fontStyle: "normal",
              fontWeight: 600,
              fontSize: "0.875rem",
            }}
            variant="outlined"
          >
            <span style={{ color: "#BF5649", fontWeight: "600" }}>Yes</span>
          </Button>
          <Button
            sx={{
              width: "43%",
              color: "#1A5AFA",
              border: "2px solid #1A5AFA",
              fontFamily: "Be Vietnam Pro",
              fontStyle: "normal",
              fontWeight: 600,
              fontSize: "0.875rem",
            }}
            variant="outlined"
            onClick={handleCloseButton}
          >
            No
          </Button>
        </div>
      </Dialog>
    </div>
  );
}

export default ReusableDeleteDialogue;
